import { render } from "./main-cart.vue?vue&type=template&id=2b9151bc"
import script from "./main-cart.vue?vue&type=script&lang=js"
export * from "./main-cart.vue?vue&type=script&lang=js"

import "./main-cart.vue?vue&type=style&index=0&id=2b9151bc&lang=scss"

import exportComponent from "/Users/ashley.eastham/Fostr Dev/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__